import { Suspense, useEffect, useState, useRef } from "react";

import close from '../../assets/icon/close.png'

// for selection of custom clothing
// import blazer from '../../assets/icon/blazer.svg'
// import trouser from '../../assets/icon/trousers.svg'
// import vest from '../../assets/icon/vest.svg'
// import Shirt from '../../assets/icon/shirt.svg'

import blazer from '../../assets/icon/SVG2/coat.svg'
import coat from "../../assets/SVG/double button-01.svg";

import trouser from '../../assets/icon/SVG2/pant.svg'
import pajama from '../../assets/SVG/SVG_PAJAMA/SALWAR-01.svg'

import vest from '../../assets/icon/SVG2/vest.svg'
import sadri from '../../assets/SVG/SVG_SADRI/STYLE 1-01.svg'

import Shirt from '../../assets/icon/SVG2/shirt.svg'

import kurta from '../../assets/SVG/SVG_KURTA/kurta.svg'

import NavImg from '../../assets/icon/edit.jpg'
import plus from '../../assets/icon/plus-thin.svg'
import tut from '../../assets/tut.png'
import info from '../../assets/icon/info1.png'
//    

import rarrow from '../../assets/icon/Rarrow.png'
import larrow from '../../assets/icon/Larrow.png'
import Switch from '@mui/material/Switch';

import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Zoom from '@mui/material/Zoom';

import bg from '../../assets/samples/bg.jpg'
import search_svg from '../../assets/icon/social/search.png'

import { getData } from "../../Firebase/firestoreGet";

import edit from '../../assets/icon/edit.png'

import {Types} from '../../Data'
import { db } from "../../firebase";
import { Fab, stepClasses } from "@mui/material";
import { checkCategory, encodeObj } from "../../Functions";
import { useNavigate } from "react-router-dom";
import ClothSelect from "../clothSelect";
import { use } from "react";
// const Types = ["Coat", "Shirt", "Pant", "Vest"]

// salwar for pajama PJ

const label = { inputProps: { 'aria-label': 'Switch demo' } };

export default function SelectFabric({category , Fabric,useFabric, setUseFabric, sel, setSel, sHover, hoverState, nav, setNav, hover,setFabricsAll, setFabricTypes, FabricTypes,menuOpen2,setMenuOpen2, menuOpen, clickHover, setClickHover, getStyleImg, setStylesAll,imgState ,setImgState, fabSame, setFabSame, fabricType, setType, process, Navs, showFilter, setShowFilter}){
    
    const [modal, setModal] = useState(0);
    const [types, setTyp] = useState([1, 0, 1, 0])

    const navigate = useNavigate()
    
    const [Ffilter, setFabricFilter] = useState(0)
    
    const [search, setSearch] = useState(false)
    const [searchQuery, setSearchQuery] = useState("");

    const [isMobile, setIsMobile] = useState(window.innerWidth < 480);
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedColor, setSelectedColor] = useState(null);
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleSidebar = () => {
        setIsExpanded(!isExpanded);
    };

    const toggleFilter = () => {
        const next = !Ffilter;
        setFabricFilter(next);
        if (setShowFilter) setShowFilter(next);
    };
    
    const sidebarRef2 = useRef(null);
    useEffect(() => {
        // Set the initial selected color to the first fabric image
        if (Fabric && Fabric[fabricType] && Fabric[fabricType][0]) {
          setSelectedColor(Fabric[fabricType][0].fabricImg);
        }
      }, [Fabric, fabricType]);
      
    const toggleDropdown = () => {
        // console.log("toggled")
        setShowDropdown((prev) => !prev);
    };
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 480);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    

    useEffect(()=>{
        if(FabricTypes){
            setType(FabricTypes[0])
        }
    }, [FabricTypes])

    const getPriceForCard = (k)=>{

        let p = 0;
        // console.log("calling getPrice : ", fabricType)

        if(fabSame && sel && fabricType != "Shirt" && sel.types){
            // console.log("this is the issue ff ", useFabric, k)
            sel.types.forEach((ele)=>{
                if(ele != "Shirt"){
                    if(useFabric[ele] &&  k < useFabric[ele].length){
                        p = p + Number(useFabric[ele][k].price)
                    }
                    
                }
            })
            
        } else {
            // console.log("this is another : ", useFabric, k)
            p = Number(useFabric[fabricType][k].price)
        }

        return (
            <span> 
                 {Number(p).toLocaleString('en-IN', {
                                                    maximumFractionDigits: 2,
                                                    style: 'currency',
                                                    currency: 'INR'
                })}
            </span>
        )
    }

    // useEffect(()=>{
        
    //     if(FabricTypes){
    //     if(imgState <= 2){
    //         setType("Coat")
    //     }
    //     if(sel && sel.types && sel.types.includes("Shirt")){
    //         if(imgState === 3){
    //             setTyp("Shirt")
    //         }
    //         else if(imgState <= 5){
    //             setTyp("Pant")
    //         } else {
    //             setTyp("Vest")
    //         }

    //     } else {
    //         console.log("Coming to else", imgState)
    //         if(imgState === 3){
    //             setTyp("Pant")
    //             console.log("Changing to pant")
    //         }
    //         else {
    //             setTyp("Vest")
    //         }
    //     }
    //     }
        

    // }, [imgState])
    
    const select = (key, typ = null)=>{
        if(key === 1 || key === 3){

            var a = [...types]

            a[key] = Number(!a[key])

            if(category === "kurta"){
                if(a[1] === 1 && a[1] === a[3]){
                    if(key === 1){
                        a[3] = 0
                    } else {
                        a[1] = 0
                    }
                }
            } 

            if(typ){
                a[key] = typ
            }
            setTyp(a)
        }
    }
    const calPrice = (a)=>{  
        let p = 0
        let D = Number(0)
        Object.keys(a["fabric"]).forEach((element)=>{
            if(a["fabric"][element]["discount"]){
                const perc = Number(a["fabric"][element]["discount"])
                D = D + (Number(a["fabric"][element]["price"])*( perc/100 ) )
            }
            p+=Number(a["fabric"][element]["price"])
        }) 

        return [p, D]
    }
    const getDiscount = (a)=>{
        
    }
    

    // const ImageWithLoading = ({ src }) => (
    //     <LoadedState>
    //       {({ state: loaded, setState: setLoaded }) => (
    //         <div>
    //           {!loaded ? (
    //             <svg width="100" height="100" viewBox="0 0 100 100">  
    //               <rect width="100" height="100" rx="10" ry="10" fill="#CCC" />
    //             </svg>
    //           ) : null}
    //           <img
    //             src={src}
    //             style={!loaded ? { visibility: 'hidden' } : {}}
    //             onLoad={() => setLoaded(true)}
    //           />
    //         </div>
    //       )}
    //     </LoadedState>
    // );

    return(
        <div className="selectFabric" style={(Ffilter == 1 && !isMobile) ? {transform:"translateX(300px)"} : {}}>
            {nav != null ? (
                <>
                    {/* Mobile Sidebar Toggle */}
                    {(isMobile && menuOpen2) && (
                        <div className={isExpanded ? 'expand-button0' : 'expand-button1'} onClick={toggleSidebar}>
                            <img src={isExpanded ? larrow : rarrow} style={{ width: "20px" }} />
                        </div>
                    )}

                    {/* Sidebar Container */}
                    <div className={`selectFabric2 ${isMobile ? (menuOpen2 ? 'show' : 'hidden') : ''} ${isExpanded ? 'expanded' : ''}`} ref={sidebarRef2}>
                        
                        {/* Header */}
                        <div className="sf-header">
                            <h3>SELECT FABRIC</h3>
                            <div className="sf-header-actions">
                                <div 
                                    className={`pill-btn ${search ? 'active' : ''}`} 
                                    onClick={() => setSearch(!search)}
                                >
                                    {search ? 'CLOSE' : 'SEARCH'}
                                </div>
                                <div className="pill-btn" onClick={toggleFilter}>FILTERS</div>
                            </div>
                        </div>

                        {/* Search Bar */}
                        {search && (
                            <div className="sf-search-container">
                                <input 
                                    placeholder="Search by brand or fabric name..."
                                    className="sf-search-input"
                                    autoFocus
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                            </div>
                        )}


                        {/* Cloth Type Scroll */}
                        <div className="sf-cloth-types-scroll">
                            {/* Suit Tab (for Same Fabric mode) */}
                            {(category === "suit" || category === "formal" || category === "kurta") && (
                                <div 
                                    className={`sf-cloth-type-item ${fabSame ? 'active' : ''}`}
                                    onClick={() => {
                                        setFabSame(true);
                                        setType("Coat"); // Default view for Suit
                                    }}
                                >
                                    SUIT
                                </div>
                            )}
                            
                            {/* Individual Types */}
                            {sel && sel.types && sel.types.map((val) => (
                                <div 
                                    key={val}
                                    className={`sf-cloth-type-item ${!fabSame && val === fabricType ? 'active' : ''}`}
                                    onClick={() => {
                                        setFabSame(false);
                                        setType(val);
                                    }}
                                >
                                    {val}
                                </div>
                            ))}
                        </div>

                        {/* Toggle: Same Fabric vs Mix Match */}
                        {(category === "suit" || category === "formal") && (
                            <div className="sf-toggle-container">
                                <div className="sf-toggle-wrapper">
                                    <div 
                                        className={`sf-toggle-option ${fabSame ? 'active' : ''}`}
                                        onClick={() => setFabSame(true)}
                                    >
                                        Same Fabric
                                    </div>
                                    <div 
                                        className={`sf-toggle-option ${!fabSame ? 'active' : ''}`}
                                        onClick={() => setFabSame(false)}
                                    >
                                        Mix Match
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Search Bar (Mobile/Desktop logic from original) */}
                        {search && (
                            <div style={{padding: '0 25px 10px 25px'}}>
                                <input 
                                    placeholder="Search fabrics..."
                                    style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ddd'}}
                                    autoFocus
                                    onBlur={() => setSearch(false)}
                                />
                            </div>
                        )}

                        {/* Fabric Grid */}
                        <div className="sf-fabric-grid">
                            {useFabric && useFabric[fabricType] && useFabric[fabricType]
                                .filter(value => 
                                    value.fabric.toLowerCase().includes(searchQuery.toLowerCase()) || 
                                    value.brand.toLowerCase().includes(searchQuery.toLowerCase())
                                )
                                .map((value, key) => (
                                <div 
                                    className={`sf-fabric-card ${sel && sel.fabric && sel.fabric[fabricType] && sel.fabric[fabricType].fabricID === value.fabricID ? 'active' : ''}`} 
                                    key={key}
                                    id={`fabriclist_${value.brand}_${value.fabric}`.replace(" ", "")}
                                    onClick={() => {
                                        // Logic to update selection
                                        let updatedSel = {...sel};
                                        if(fabSame && fabricType!== "Shirt" && sel){
                                            sel.types.forEach((ele)=>{
                                                if(ele !== "Shirt"){
                                                    let value_ele = useFabric[ele].filter(e=>e.fabricID === value.fabricID);
                                                    if(!value_ele.length) value_ele = useFabric[ele][0];
                                                    else value_ele = value_ele[0];

                                                    // Ensure fabric object structure exists
                                                    if(!updatedSel.fabric) updatedSel.fabric = {};
                                                    
                                                    updatedSel.fabric[ele] = {
                                                        ...value_ele,
                                                        pos: Types[category] ? Types[category][ele] : null,
                                                        recommended_buttons: value_ele.recommended_buttons || []
                                                    };
                                                }
                                            });
                                        } else {
                                            if(!updatedSel.fabric) updatedSel.fabric = {};
                                            updatedSel.fabric[fabricType] = {
                                                ...value,
                                                pos: Types[category] ? Types[category][fabricType] : null,
                                                recommended_buttons: value.recommended_buttons || []
                                            };
                                        }
                                        
                                        const price = calPrice(updatedSel);
                                        getStyleImg({...updatedSel, price: price[0], discount: price[1]}, 1);
                                    }}
                                >
                                    <img src={value.fabricImg} className="sf-fabric-img" loading="lazy" alt={value.fabric} />
                                    
                                    <div className="sf-fabric-info">
                                        <div className="sf-fabric-text">
                                            <div className="sf-marquee">
                                                <div className="sf-marquee-track">
                                                    <span className="sf-fabric-name">{value.fabric}</span>
                                                    <span className="sf-fabric-divider"> | </span>
                                                    <span className="sf-fabric-brand">{value.brand.toUpperCase()}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="sf-fabric-price">{getPriceForCard(key)}</div>
                                    </div>

                                    {/* Info Button */}
                                    <div 
                                        className="sf-info-btn"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            hoverState(-1);
                                            sHover({
                                                q: value.fabricID,
                                                name: value.fabric || value.name || "",
                                                brand: value.brand || "",
                                                brandImg: value.brandImg || "",
                                                des: value.des || "",
                                                src: value.fabricImg || value.src || "",
                                                single: Array.isArray(value.single) ? value.single : [],
                                                material: value.material || "",
                                                color: value.color || "",
                                                pattern: value.pattern || "",
                                                weave: value.weave || "",
                                                width: value.width || ""
                                            });
                                            // Trigger info modal
                                        }}
                                    >
                                        i
                                    </div>
                                </div>
                            ))}
                            
                            {/* Loading State / Empty Placeholders */}
                            { (!useFabric || !useFabric[fabricType]) && (
                                <>
                                    {[1,2,3,4].map(i => (
                                        <div key={i} className="sf-fabric-card" style={{background: '#eee'}}></div>
                                    ))}
                                </>
                            )}
                        </div>


                    </div>
                </>
            ) : (
                <div className="flex items-center justify-center h-full">Loading...</div>
            )}
        </div>
    )
}
